// ABOUTME: The inbound figures panel: what a period has coming in, beside those inbounds over time.
// ABOUTME: A relation session is scoped to its own inbounds by the API, so both environments mount it as is.

import { useTranslation } from "react-i18next";
import CallReceivedOutlinedIcon from '@mui/icons-material/CallReceivedOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import ShTotalsPanel from "../../theme/cards/ShTotalsPanel";
import { useGetInboundDashboardChartQuery, useGetInboundDashboardTotalsQuery } from "../../../newapi/dashboard/dashboardSlice";

const InboundTotalsPanel = () => {
    const { t } = useTranslation();

    return (
        <ShTotalsPanel
            useTotals={useGetInboundDashboardTotalsQuery}
            useChart={useGetInboundDashboardChartQuery}
            chartSubtitles={{
                month: t("inbounds_per_month"),
                week: t("inbounds_per_week")
            }}
            chartSeries={[
                { type: "number" },
                { type: "number", chartType: "hidden" },
                { type: "number", chartType: "hidden" },
            ]}
            cards={[
                { key: "inboundCount", label: t("inbounds"), icon: <CallReceivedOutlinedIcon className="logo"/>, color: "blue", type: "number" },
                { key: "skuCount", label: t("sku_count"), icon: <CategoryOutlinedIcon className="logo"/>, color: "purple", type: "number" },
                { key: "itemCount", label: t("items"), icon: <Inventory2OutlinedIcon className="logo"/>, color: "orange", type: "number" },
                { key: "avgLinesPerInbound", label: t("avg_lines_per_inbound"), icon: <FormatListBulletedIcon className="logo"/>, color: "green", type: "number" },
            ]}
        />
    );
};

export default InboundTotalsPanel;
